import { requestRefreshToken } from './auth-network';
import { decodeToken, isTokenNotExpired } from './AuthUtil';
import {
  getAccessToken,
  getCredentialsSession,
  persistCredentialsSession,
  clearCredentialsSession,
} from './auth-storage';

export const isAuthenticated = () => {
  const accessToken = getAccessToken();

  if (!accessToken) {
    return false;
  }

  const data = getCredentialsSession();

  const decodedAccessToken = decodeToken(data.accessToken);
  const decodedRefreshToken = decodeToken(data.refreshToken);

  const accessTokenIsNotExpired = isTokenNotExpired(decodedAccessToken.exp);
  const refreshTokenIsNotExpired = isTokenNotExpired(decodedRefreshToken.exp);

  return accessTokenIsNotExpired && refreshTokenIsNotExpired;
};

export const restoreCredentials = () => {
  // Try to restore previous existing session
  try {
    // Get access token and refresh token from session storage
    const data = getCredentialsSession();
    const decodedAccessToken = decodeToken(data.accessToken);

    if (isTokenNotExpired(decodedAccessToken.exp)) {
      // Access token valid and not expired yet, restore credentials process success
      return Promise.resolve();
    }

    // Access token expired, check refresh token
    const decodedRefreshToken = decodeToken(data.refreshToken);

    if (isTokenNotExpired(decodedRefreshToken.exp)) {
      // Refresh token valid and not expired yet, try to get new access token
      return requestRefreshToken(data.refreshToken)
        .then((response) => {
          const newToken = response.data.refreshToken.token;
          persistCredentialsSession(newToken, data.refreshToken);

          return Promise.resolve();
        }).catch(() => {
          clearCredentialsSession();
          return Promise.reject();
        });
    }

    throw new Error('Restore credentials process failed');
  } catch (error) {
    // Error during restore, restore credentials process failed
    clearCredentialsSession();
    return Promise.reject();
  }
};

export const invalidateSession = () => {
  clearCredentialsSession();
  return Promise.resolve();
};
